<template>
  <el-autocomplete
    v-model="value"
    class="inline-input"
    :fetch-suggestions="querySearch"
    placeholder="请输入内容"
    style="width:100%"
    clearable
    @select="changeValue($event)"
  >
    <template slot-scope="{ item }">
      <div
        class="name"
        :title="item.value"
      >
        <span style="float:left">{{ item.value }}</span><span
          style="float: right ; color: #8492a6; font-size: 12px"
        >&nbsp;&nbsp;1{{ item.unitName }}={{ item.convertedQuantity }}{{ item.auxiliaryUnitName }}</span>
      </div>
    </template>
  </el-autocomplete>
</template>

<script>
  // auxiliaryUnitCode: "018dcce4523a4dc4b99886e473f34463"
  // auxiliaryUnitName: "单位2"
  // barCode: "5"
  // code: "e9ecb1909fa64a9da4d6d211b7bb8919"
  // mnemonic: "2"
  // name: "1"
  // spec: "3"
  // typeCode: "zhongban"
  // unitCode: "cf6f24762ac543a389d28ef6cc3b328c"
  // unitName: "网址"
  import request from '@/utils/request'

  export default {
    data() {
      return {
        value: '',
        goodsList: [],
        callbackMethod: '',
        queryString: ''
      }
    },
    created() {
    },
    mounted() {

    },
    methods: {
      querySearch(queryString, callback) {
        var list = [{}]
        request({
          url: '/ntocc-basic-api/goods/findGoods',
          method: 'get',
          params: { queryParam: queryString }
        }).then(response => {
          this.goodsList = response.data
        })
          .then((response) => {
            for (let i of this.goodsList) {
              i.value = i.name
            }
            list = this.goodsList
            callback(list)
          }).catch((error) => {
        })
      },
      setSelectValue(value) {
        this.value = value
      },
      changeValue(e) {
        e.name = e.value
        this.$emit('setGoodsCode', e)
      }
    }
  }
</script>
